export const DESKTOP_COLLAPSED_ITEMS_COUNT = 4;

export const MOBILE_COLLAPSED_ITEMS_COUNT = 3;
